import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import type {
  CancelSubscriptionRequest,
  ChangeEndDateRequest,
  ChangeStartDateRequest,
  EarliestCancellationDatePreviewResponse,
  EditTimelinePricingRequest,
  EditTimelinePricingResponse,
  ImmediateRecentValidateDateRequest,
  ImmediateRecentValidateDateResponse,
  ListActiveSubscription,
  ListCancellationReasons,
  SubscriptionCycleExceptionRequest,
} from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { Observable, map, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientSubscriptionService {
  private http = inject(HttpClient);

  
  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  httpPatchOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json-patch+json',
    })
  };

  CancelSubscription(tenantId:number,clientId:number,subsciptionId:number, cancelSubscription: CancelSubscriptionRequest)
  {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.CANCEL_SUBSCRIPTION.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{client_subs_id}', subsciptionId.toString());
    return this.http.post<CancelSubscriptionRequest>(url,cancelSubscription,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }),
    catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  GetClientActiveSubscriptionMemberships(clientId:number): Observable<ListActiveSubscription>
  {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.ACTIVE_SUBSCRIPTION_MEMBERSHIP.replace('{client_id}', clientId.toString());
    return this.http.get<CancelSubscriptionRequest>(url,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }),
    catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }


  ChangeMembershipStartDate(tenantId:number,clientId:number,subsciptionId:number, membershipId:number, editRequest: ChangeStartDateRequest)
  {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.PUT_START_DATE_MEMBERSHIP.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{client_subscription_id}', subsciptionId.toString()).replace('{client_membership_id}', membershipId.toString());
    return this.http.put<ChangeStartDateRequest>(url,editRequest,{headers: this.httpPatchOptions.headers}).pipe(map((res: any) => {
        return res;
    }),
    catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  ChangeMembershipEndDate(tenantId:number,clientId:number,subsciptionId:number, membershipId:number, editRequest: ChangeEndDateRequest)
  {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.PUT_END_DATE_MEMBERSHIP.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{client_subscription_id}', subsciptionId.toString()).replace('{client_membership_id}', membershipId.toString());
    return this.http.put<ChangeEndDateRequest>(url,editRequest,{headers: this.httpPatchOptions.headers}).pipe(map((res: any) => {
        return res;
    }),
    catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  ChangeSubscriptionStartDate(tenantId:number,clientId:number,subsciptionId:number, editRequest: ChangeStartDateRequest)
  {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.PUT_START_DATE_SUBSCRIPTION.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{client_subscription_id}', subsciptionId.toString());
    return this.http.put<ChangeStartDateRequest>(url,editRequest,{headers: this.httpPatchOptions.headers}).pipe(map((res: any) => {
        return res;
    }),
    catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  ChangeSubscriptionEndDate(tenantId:number,clientId:number,subsciptionId:number, editRequest: ChangeEndDateRequest)
  {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.PUT_END_DATE_SUBSCRIPTION.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{client_subscription_id}', subsciptionId.toString());
    return this.http.put<ChangeEndDateRequest>(url,editRequest,{headers: this.httpPatchOptions.headers}).pipe(map((res: any) => {
        return res;
    }),
    catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  ActivateMembership(tenantId:number,clientId:number,subsciptionId:number, changeRequest: any)
  {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.ACTIVATE_SUBSCRIPTION.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{client_subscription_id}', subsciptionId.toString());
    return this.http.post(url,changeRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }),
    catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  MidCycleDiscount(tenantId:number,clientId:number,subsciptionId:number, payload: SubscriptionCycleExceptionRequest)
  {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.RECURRING_ACCURENCE_EXCEPTION.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{client_subscription_id}', subsciptionId.toString());
    return this.http.post(url,payload,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }),
    catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  ReActivateMembership(tenantId:number,clientId:number,subsciptionId:number, changeRequest: any)
  {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.RE_ACTIVATE_SUBSCRIPTION.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{client_subscription_id}', subsciptionId.toString());
    return this.http.post(url,changeRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }),
    catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  ChangeMembershipSessions(tenantId:number,clientId:number,subsciptionId:number, membershipId:number, patchRequest: any)
  {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.CHANGE_MEMBERSHIP_SESSIONS.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{client_subscription_id}', subsciptionId.toString()).replace('{client_membership_id}', membershipId.toString());
    return this.http.patch<any>(url,patchRequest,{headers: this.httpPatchOptions.headers}).pipe(map((res: any) => {
        return res;
    }),
    catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  GetCancellationReasons(tenantId: number): Observable<ListCancellationReasons>
  {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.CANCELLATION_REASONS.replace('{tenant_id}', tenantId.toString());
    return this.http.get<ListCancellationReasons>(url, {headers: this.httpOptions.headers}).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetEarliestCancellationDatePreview(
    tenantId: number,
    clientId: number,
    subscriptionId: number,
  ): Observable<EarliestCancellationDatePreviewResponse> {
    const url =
      this.BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTION.EARLIEST_CANCELLATION_DATE_PREVIEW.replace(
        '{tenant_id}',
        tenantId.toString(),
      )
        .replace('{client_id}', clientId.toString())
        .replace('{client_subs_id}', subscriptionId.toString());

    return this.http
      .get<EarliestCancellationDatePreviewResponse>(url, {
        headers: this.httpOptions.headers,
      })
      .pipe(
        map((res) => res),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        }),
      );
  }

  ValidateImmediateRecentCancellationDate(
    tenantId: number,
    clientId: number,
    subscriptionId: number,
    payload: ImmediateRecentValidateDateRequest,
  ): Observable<ImmediateRecentValidateDateResponse> {
    const url =
      this.BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTION.IMMEDIATE_RECENT_VALIDATE_DATE.replace(
        '{tenant_id}',
        tenantId.toString(),
      )
        .replace('{client_id}', clientId.toString())
        .replace('{client_subs_id}', subscriptionId.toString());

    return this.http
      .post<ImmediateRecentValidateDateResponse>(url, payload, {
        headers: this.httpOptions.headers,
      })
      .pipe(
        map((res) => res),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        }),
      );
  }

  EditTimelinePricing(
    tenantId: number,
    clientId: number,
    subscriptionId: number,
    payload: EditTimelinePricingRequest,
  ): Observable<EditTimelinePricingResponse> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.EDIT_TIMELINE_PRICING
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{subscription_id}', subscriptionId.toString());

    return this.http.post<EditTimelinePricingResponse>(url, payload, { headers: this.httpOptions.headers }).pipe(
      map((res: EditTimelinePricingResponse) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      }),
    );
  }

}
